/**
 * 単一の email validation 正規表現。
 *
 * UI 側 form 検証 (register / contact / change-email) で重複していたものを集約。
 *
 * 設計判断:
 *   - RFC 5321 完全準拠ではなく、UI で typo を弾く実用パターン (`{local}@{domain}.{tld}`)。
 *   - サーバ側 (NestJS class-validator) でも別途 IsEmail で再検証されるため、
 *     ここでは 軽量 / 高速 / false-positive 寛容 の設計が適切。
 *   - 文章中の email を抜き出す pattern (HighlightEmails の `EMAIL_PATTERN`) とは
 *     用途が異なるので統合しない (一方は anchor あり、他方は global 抽出)。
 */

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u

export const isValidEmail = (input: string): boolean => EMAIL_RE.test(input.trim())
